import useMonetizacion from "@/features/monetizacion/hooks/use-monetizacion";
import NumberField, { NumberFieldProps } from "./number-field";
import { Box, Stack } from "@mui/material";

export interface MonedaFieldProps extends NumberFieldProps {
    monedaId?: string
}

export default function MonedaField({
    alignRight = true,
    monedaId,
    ...props
}: MonedaFieldProps) {
    const { monedaBase, monedas } = useMonetizacion();

    const monedaFinal = monedaId ? monedas.find(m => m.id === monedaId) : monedaBase;

    if (!monedaFinal) throw new Error("La moneda Id es invalida.");

    return <NumberField
        {...props}
        alignRight={alignRight}
        slotProps={{
            ...props.slotProps,
            input: {
                ...props.slotProps?.input,
                endAdornment: <Stack direction={"row"} gap={1} alignItems={"center"}>
                    <Box> &nbsp;{monedaFinal.simbolo} </Box>
                    <Box> {(props.slotProps?.input as any)?.endAdornment} </Box>
                </Stack>
            }
        }}
    />
}